import React from "react";
import { Typography, Grid, Box, styled } from "@mui/material";

import appleQrCode from "assets/img/kardia_app_appstore_QR.svg";
import androidQrCode from "assets/img/kardia_app_playstore_QR.svg";
import { ReactComponent as AppStore } from "assets/img/appStore.svg";
import { ReactComponent as GooglePlay } from "assets/img/googlePlay.svg";
import { ReactComponent as Round } from "assets/img/round.svg";
import { appsStoreNavigation } from "utilities";
import { STEPS_AFTER_PROGRAM_ENROLLMENT } from "constants/enrollment";
import Page from "components/ui/Page/Page";

const List = styled(Box)({
    display: "flex",
    padding: "0px 40px",
    textAlign: "left",
    marginBottom: 15,
    "& .stepsContainer svg": {
        display: "flex",
        alignItems: "flex-start",
        paddingTop: 15,
    },
    "& .step-text": {
        marginLeft: 5,
        fontWeight: 700,
    },
});

//Render steps
const renderStep = (step, index) => (
    <List key={index} className="stepsContainer">
        <Box>
            <Round />
        </Box>
        <Typography variant="h6" className="step-text">
            {step}
        </Typography>
    </List>
);

const EnrollmentSuccess = () => (
    <Page
        sx={{ maxWidth: "1100px" }}
        heading="Your account has successfully been created! Please scan the QR code to download the app."
    >
        <Grid
            container
            mt={5}
            gap={8}
            flexDirection={"column"}
            sx={{
                width: { xs: "100%", md: "85%" },
                textAlign: "center",
            }}
        >
            <Grid item gap={3}>
                {STEPS_AFTER_PROGRAM_ENROLLMENT.map(renderStep)}
            </Grid>
            {/* Store logo, QR code section */}
            <Grid
                container
                item
                flex={1}
                justifyContent={"center"}
                gap={10}
                sx={{
                    width: "95%",
                }}
            >
                {/* Apple store and QR code section */}
                <Grid item flex={1} justifyContent={"center"} container gap={2}>
                    <AppStore onClick={appsStoreNavigation} role="button" />
                    <Typography
                        variant="h6"
                        px={6}
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        If you have an iPhone, please scan this QR code to download the app.
                    </Typography>
                    <img
                        alt="QR code to download the KardiaComplete app"
                        src={appleQrCode}
                    />
                </Grid>

                {/* Google Play and QR code section */}
                <Grid item flex={1} justifyContent={"center"} container gap={2}>
                    <GooglePlay onClick={appsStoreNavigation} role="button" />
                    <Typography
                        variant="h6"
                        px={6}
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        If you have an Android, please scan this QR code to download the
                        app.
                    </Typography>
                    <img
                        alt="QR code to download the KardiaComplete app"
                        src={androidQrCode}
                    />
                </Grid>
            </Grid>

            {/* Email Note Section */}
            <Grid item>
                <Typography>
                    You will receive a confirmation email from support@alivecor.com
                    confirming when your devices have shipped. If you have questions or
                    concerns please feel free to reach out to our customer care team.
                </Typography>
            </Grid>
        </Grid>
    </Page>
);

export default EnrollmentSuccess;
